export type RoleCode = "CSR1" | "CSR2" | "CSR3" | "SUP" | "BO" | "IT";

export type Permissions = {
  customer: boolean;
  cpni: boolean;
  adjust: boolean;
  adjustLimit: number;
  offers: boolean;
  retention: boolean;
  services: boolean;
  orders: boolean;
  reports: boolean;
  admin: boolean;
};

export type RoleDefinition = {
  code: RoleCode;
  name: string;
  perms: Permissions;
};

export const ROLE_MATRIX: Record<RoleCode, RoleDefinition> = {
  CSR1: {
    code: "CSR1",
    name: "CSR Level 1",
    perms: {
      customer: true,
      cpni: true,
      adjust: false,
      adjustLimit: 0,
      offers: true,
      retention: false,
      services: true,
      orders: false,
      reports: false,
      admin: false,
    },
  },
  CSR2: {
    code: "CSR2",
    name: "CSR Level 2",
    perms: {
      customer: true,
      cpni: true,
      adjust: true,
      adjustLimit: 25,
      offers: true,
      retention: false,
      services: true,
      orders: false,
      reports: false,
      admin: false,
    },
  },
  CSR3: {
    code: "CSR3",
    name: "CSR Level 3",
    perms: {
      customer: true,
      cpni: true,
      adjust: true,
      adjustLimit: 100,
      offers: true,
      retention: true,
      services: true,
      orders: true,
      reports: false,
      admin: false,
    },
  },
  SUP: {
    code: "SUP",
    name: "Supervisor",
    perms: {
      customer: true,
      cpni: true,
      adjust: true,
      adjustLimit: 500,
      offers: true,
      retention: true,
      services: true,
      orders: true,
      reports: true,
      admin: false,
    },
  },
  BO: {
    code: "BO",
    name: "Back Office",
    perms: {
      customer: true,
      cpni: true,
      adjust: true,
      adjustLimit: 250,
      offers: false,
      retention: false,
      services: true,
      orders: true,
      reports: false,
      admin: false,
    },
  },
  IT: {
    code: "IT",
    name: "IT Administrator",
    perms: {
      customer: false,
      cpni: false,
      adjust: false,
      adjustLimit: 0,
      offers: false,
      retention: false,
      services: false,
      orders: false,
      reports: true,
      admin: true,
    },
  },
};

export const ROLE_OPTIONS = Object.values(ROLE_MATRIX);

export function isRoleCode(value: string): value is RoleCode {
  return value in ROLE_MATRIX;
}

export function minRoleFor(key: "retention" | "adjust" | "orders" | string): string {
  if (key === "retention") return "CSR L3";
  if (key === "adjust") return "CSR L2";
  if (key === "orders") return "CSR L3";
  return "Supervisor";
}
